module.exports = __webpack_public_path__ + "images/close-popup656bdc66cddf0257514dc0350ee31ee0.svg";